/**
 * 時間とフレーム（索引 Issue #498 の段階 1。設計文書 docs/editor-core-design.md §2）。
 *
 * **コアの時刻はすべて ms の整数**で、区間は半開 `[startMs, endMs)`。丸めはここ 1 か所（`snapToFrame`）に集約する
 * —— 場所ごとに floor / round が混ざると、同じ値がフレーム 1 つぶんずれて「帯の間に 1 フレームの穴が空く」類の
 * 不具合になる。
 */
export const DEFAULT_FPS = 30;

const isFps = (fps) => Number.isFinite(fps) && fps > 0;

/** 読めない値を既定に落とす（文書から読んだ fps の検め） */
export const readFps = (fps) => (isFps(fps) ? fps : DEFAULT_FPS);

/** フレームの頭の ms（整数）へ丸める */
export const snapToFrame = (ms, fps = DEFAULT_FPS) => {
  const f = readFps(fps);
  return Math.round((Math.round((ms * f) / 1000) * 1000) / f);
};
